import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import { IS_PRODUCTION } from 'src/constants/env';
import rootReducer from '../reducers';

function configureStore() {
    if (IS_PRODUCTION) {
        return createStore(rootReducer, applyMiddleware(reduxThunk));
    }

    if (
        typeof window !== 'undefined' &&
        (window as any).__REDUX_DEVTOOLS_EXTENSION__
    ) {
        return createStore(
            rootReducer,
            compose(
                applyMiddleware(reduxThunk),
                (window as any).__REDUX_DEVTOOLS_EXTENSION__({})
            )
        );
    }

    return createStore(rootReducer, compose(applyMiddleware(reduxThunk)));
}

const store = configureStore();

export default store;
